import React from "react"
import ResVideo from "../../../components/resVideo"
import ResImg from "../../../components/resImg"

const FullWidthImage = (props) => {

    const blok = props.blok

    const hasVideo = blok.video?.filename != undefined && blok.video?.filename != ""

    const hasLink = blok.link?.url != undefined && blok.link?.url != ""

    return (
        <section className="width relative">
             {
                    hasVideo ? (
                        <ResVideo mobileVideo={blok.mobile_video} desktopVideo={blok.video} mobilePoster={blok.mobile_image} desktopPoster={blok.image} className='w-full object-cover'/>
                    ):
                    (
                        <ResImg mobile={blok.mobile_image} desktop={blok.image} className='w-full object-cover'/>
                    )
                }
            {hasLink && (
                <a href={blok.link.url} className="absolute h-full top-0 bottom-0 left-[20px] right-[20px] lg:left-[min(2.6vw,50px)] lg:right-[min(2.6vw,50px)]">
                    <span className="sr-only">{blok.link_label || blok.image.title || blok.video.title }</span>
                </a>
            )}    
        </section>
    )
}

export default FullWidthImage